import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  cancelBtn: {
    width: "180px",
    backgroundColor: "white",
    color: "#FF712D",
    border: "1px solid #FF712D",
    borderRadius: "4px",
    padding: "8px 20px",
    fontSize: "16px",
    fontWeight: 500,
    fontFamily: "Roboto",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    "&.Mui-disabled": {
      backgroundColor: "#AEA198",
      color: "#ffffff",
    },
  },
  proceedBtn: {
    width: "180px",
    backgroundColor: "#FF712D",
    color: "#FFFFFF",
    borderRadius: "4px",
    padding: "8px 20px",
    fontWeight: 500,
    fontSize: "16px",
    textTransform: "none",
    fontFamily: "Roboto",
    "&:hover": {
      backgroundColor: "#FF712D",
    },
    "&.Mui-disabled": {
      backgroundColor: "#AEA198",
      color: "#ffffff",
    },
  },
}));
